// Static defaults only. Viewport-dependent sider geometry is owned by
// BasicLayout via useResponsive — baking fixSiderbar/siderWidth from
// window.innerWidth at module load made DevTools resizes require a refresh.
export default {
  navTheme: 'light',
  primaryColor: '#296DFF',
  layout: 'sidemenu',
  contentWidth: 'Fluid',
  fixedHeader: true,
  autoHideHeader: false,
  fixSiderbar: true,
  menu: {
    locale: true,
  },
  title: 'AUTOMY',
  pwa: true,
  iconfontUrl: '',
  collapsedButtonRender: false,
  siderWidth: 304,
};
